import { useEffect, useState } from 'react';
import { useFeatureToggle } from '@bizzabo/feature-toggle-client';

export const SCROLL_DOWN = 'SCROLL_DOWN';
export const SCROLL_UP = 'SCROLL_UP';

type ScrollTypes = typeof SCROLL_DOWN | typeof SCROLL_UP | null;
type ScrollHook = (accuracyAppearance?: number) => {
    scrollDirection: ScrollTypes;
};

export const useScrollHook: ScrollHook = (accuracyAppearance = 80) => {
    const [scrollDirection, setScrollDirection] = useState<ScrollTypes>(null);
    const isHideNavigationEnabled = useFeatureToggle('hide-navigation', false);
    const shouldTrackScroll = isHideNavigationEnabled;
    let lastScrollTop = 0;

    const scrollHandler = e => {
        if (shouldTrackScroll) {
            if (e.target instanceof Element) {
                const scrollTop = e.target.scrollTop;
                if (scrollTop >= lastScrollTop + accuracyAppearance) {
                    setScrollDirection(SCROLL_DOWN);
                    lastScrollTop = scrollTop;
                } else if (scrollTop <= lastScrollTop - accuracyAppearance || scrollTop === 0) {
                    setScrollDirection(SCROLL_UP);
                    lastScrollTop = scrollTop;
                }
            }
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', scrollHandler, true);
        return () => window.removeEventListener('scroll', scrollHandler, true);
    }, []);

    return { scrollDirection };
};
